import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import purchaseOrderItemApi, {
  PurchaseOrderItemData,
  PurchaseOrderItemUpdateRequest
} from '../apis/purchaseOrderItem.api'
import { VendorData } from '../apis/vendor.api'
import { ContactSiteData } from '../apis/contactSite.api'
import alertService from '../services/alert.service'
import Card from '../components/Card'
import CardButton from '../components/CardButton'
import DatePicker from '../components/DatePicker/DatePicker'
import InputText from '../components/InputText'
import PageHeading from '../components/PageHeading'
import Row from '../components/Row/Row'
import VendorAndSiteSelect from '../components/VendorAndSiteSelect'

interface PurchaseOrderEditFormProps {
  purchaseOrderItem: PurchaseOrderItemData
}

interface PurchaseOrderEditFormState {
  line: string
  lineQuantity: string
  deliveryAt: string
  vendor: string
  vendorId: number | null
  vendorSiteId: string
  vendors: VendorData[],
  vendorSites: ContactSiteData[]
}

export default class PurchaseOrderEditForm
  extends Component<PurchaseOrderEditFormProps, PurchaseOrderEditFormState> {
  constructor (props: PurchaseOrderEditFormProps) {
    super(props)
    this.state = {
      line: '',
      lineQuantity: '',
      deliveryAt: this.datetimeNow,
      vendor: '',
      vendorId: null,
      vendorSiteId: '',
      vendors: [],
      vendorSites: []
    }
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleSaveClick = this.handleSaveClick.bind(this)
  }

  get datetimeNow () {
    return dateUtil.now()
  }

  get itemQuantityInput () {
    const { purchaseOrderItem } = this.props
    if (!purchaseOrderItem.item) return
    return (
      <InputText
        name="lineQuantity"
        value={this.state.lineQuantity}
        label={i18n("Line quantity")}
        onChange={this.handleInputChange} />
    )
  }

  setCurrentValues () {
    const { purchaseOrderItem } = this.props
    if (
      !purchaseOrderItem.purchaseOrder ||
      !purchaseOrderItem.item ||
      !purchaseOrderItem.item.category
    ) return
    const { purchaseOrder } = purchaseOrderItem
    const state = {
      line: purchaseOrder.line,
      lineQuantity: String(purchaseOrderItem.quantity),
      deliveryAt: purchaseOrder.deliveryAt
    }
    this.setState(state)
  }

  update (payload: PurchaseOrderItemUpdateRequest) {
    purchaseOrderItemApi.update(
      this.props.purchaseOrderItem.id,
      payload,
      purchaseOrderItem => {
        if (!purchaseOrderItem) return
        alertService.success('Successfully updated')
      })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'line') this.setState({ line: value })
    else if (name === 'lineQuantity') this.setState({ lineQuantity: value })
  }

  handleDateChange (name: string, date: string) {
    if (name === 'deliveryAt') this.setState({ deliveryAt: date })
  }

  handleSaveClick () {
    const { line, lineQuantity, deliveryAt, vendorSiteId } = this.state
    const payload: PurchaseOrderItemUpdateRequest = {}
    if (line) payload.line = line
    if (lineQuantity) payload.quantity = Number(lineQuantity)
    if (deliveryAt) payload.deliveryDate = deliveryAt
    if (vendorSiteId) payload.vendorSite = vendorSiteId
    this.update(payload)
  }

  handleVendorsChange = (vendors: VendorData[]) => {
    this.setState({ vendors })
  }

  handleVendorSitesChange = (vendorSites: ContactSiteData[]) => {
    this.setState({ vendorSites })
  }

  handleVendorIdChange = (vendorId: number | null) => {
    this.setState({ vendorId })
  }

  handleVendorSiteIdChange = (vendorSiteId: string) => {
    this.setState({ vendorSiteId })
  }

  handleVendorChange = (vendor: string) => {
    this.setState({ vendor })
  }

  componentDidMount () {
    this.setCurrentValues()
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Edit Purchase Order")}
          doc='purchase-orders-edit-purchase-order' />
        <Row column={2}>
          <InputText
            name="line"
            value={this.state.line}
            label={i18n("Line")}
            onChange={this.handleInputChange} />
          {this.itemQuantityInput}
          <DatePicker
            name="deliveryAt"
            value={this.state.deliveryAt}
            label={i18n("Delivery date")}
            onChange={this.handleDateChange} />
          <VendorAndSiteSelect
            vendor={this.state.vendor}
            vendorSiteId={this.state.vendorSiteId}
            vendors={this.state.vendors}
            vendorSites={this.state.vendorSites}
            onVendorIdChange={this.handleVendorIdChange}
            onVendorSiteIdChange={this.handleVendorSiteIdChange}
            onVendorChange={this.handleVendorChange}
            onVendorsChange={this.handleVendorsChange}
            onVendorSitesChange={this.handleVendorSitesChange} />
        </Row>
        <CardButton
          proceedText={i18n("Save")}
          cancelText={i18n("Cancel")}
          onProceedClick={this.handleSaveClick} />
      </Card>
    )
  }
}
